export { S as SERVICES } from '../services-8eb03020.js';

const DASHBOARD_SERVICE = 'actiondesk';

export { DASHBOARD_SERVICE };
